import { render } from "./ExpertiseBoxes.vue?vue&type=template&id=e6d70758"
import script from "./ExpertiseBoxes.vue?vue&type=script&lang=js"
export * from "./ExpertiseBoxes.vue?vue&type=script&lang=js"

import "./ExpertiseBoxes.vue?vue&type=style&index=0&id=e6d70758&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__